/**
 * Vuesax Notification Override Plugin
 * 
 * This plugin wraps the original $vs.notify to enforce consistent behavior:
 * - Always top-right position
 * - Longer default duration (5s instead of 2s)
 * - Consistent configuration
 * 
 * This ensures ALL notifications across the app are consistent,
 * even if developers use $vs.notify directly instead of $notify service.
 */

export default {
  install(Vue) {
    // Wait for Vuesax to be available
    Vue.mixin({
      mounted() {
        // Only run once on root instance
        if (this.$root === this && this.$vs && this.$vs.notify) {
          // Store original notify function
          const originalNotify = this.$vs.notify.bind(this.$vs)

          // Override with our consistent version
          this.$vs.notify = function(options) {
            // Ensure options is an object
            const config = typeof options === 'object' ? { ...options } : {}

            // Enforce consistent defaults
            const enhancedConfig = {
              // Default position: bottom-right (unless explicitly set)
              // Keep bottom-right to match client expectations
              position: config.position || 'bottom-right',
              
              // Default duration: 5s (unless explicitly set)
              // Original default was 2s which is too short
              time: config.time !== undefined ? config.time : 5000,
              
              // Icon pack: feather (for consistency)
              iconPack: config.iconPack || 'feather',
              
              // Spread the rest of the config
              ...config
            }

            // If no icon specified but we know the type, add appropriate icon
            if (!enhancedConfig.icon) {
              const colorIconMap = {
                success: 'icon-check-circle',
                danger: 'icon-alert-circle',
                warning: 'icon-alert-triangle',
                primary: 'icon-info',
                dark: 'icon-info',
              }
              
              if (enhancedConfig.color && colorIconMap[enhancedConfig.color]) {
                enhancedConfig.icon = colorIconMap[enhancedConfig.color]
              }
            }

            // Call original notify with enhanced config
            return originalNotify(enhancedConfig)
          }

          console.info('✓ Vuesax notifications enhanced with consistent positioning')
        }
      }
    })
  }
}

